import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Cookies() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-background text-gray-300 p-6 sm:p-10">
      <div className="max-w-3xl mx-auto">
        <button onClick={() => nav(-1)} className="text-sm text-muted-foreground hover:text-white flex items-center gap-1 mb-6"><ArrowLeft className="w-4 h-4" /> Powrót</button>
        <img src="/tmc-logo.png" alt="The Money Club" className="w-14 h-14 rounded-xl border border-primary/40 mb-4" />
        <h1 className="font-head text-3xl font-extrabold text-white mb-6">Polityka cookies</h1>
        <div className="space-y-4 text-sm leading-relaxed">
          <p>The Money Club używa plików cookie niezbędnych do działania serwisu.</p>
          <h2 className="text-white font-semibold text-lg">Cookies niezbędne</h2>
          <p>Używamy bezpiecznych plików cookie (httpOnly) do utrzymania Twojej sesji logowania (access_token / refresh_token). Bez nich logowanie nie działa.</p>
          <h2 className="text-white font-semibold text-lg">Preferencje</h2>
          <p>Zapisujemy lokalnie Twój wybór języka (PL/EN), aby strona wyświetlała się w preferowanej wersji.</p>
          <h2 className="text-white font-semibold text-lg">Zarządzanie</h2>
          <p>Możesz usuwać pliki cookie w ustawieniach przeglądarki. Usunięcie cookie sesji spowoduje wylogowanie.</p>
          <h2 className="text-white font-semibold text-lg">Kontakt</h2>
          <p>Pytania? Napisz na Telegramie: <a className="gold-text" href="https://t.me/bwattola" target="_blank" rel="noreferrer">@bwattola</a>.</p>
        </div>
      </div>
    </div>
  );
}
